<template>
  <div class="DataStatus">
    <div class="status">
      <span class="text">企业发票数据</span>
      <!-- <div
        class="textVal0"
        v-if="collectCode === '0'"
      >{{collectMessage || '--'}}</div>
      <div
        class="textVal1"
        v-if="collectCode === '1'"
      >{{collectMessage || '--'}}</div>
      <div
        class="textVal2"
        v-if="collectCode === '2'"
      >{{collectMessage || '--'}}</div>
      <div
        class="textVal3"
        v-if="collectCode === '3'"
      >{{collectMessage || '--'}}</div> -->
    </div>
    <div>
      <!-- <div
        v-show="tab"
        class="refresh"
        @click="refresh()"
      >
        <img
          src="@/assets/images/refreshIcon.png"
          class="refreshIcon"
        >
        刷新
      </div> -->
      <!-- <van-loading
        v-show="!tab"
        class="spinner"
        size="16px"
        color="#ff6538"
        type="spinner"
      /> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataStatus',
  data() {
    return {
      // tab: true,
      collectMessage: '',
      collectCode: '',
      intervalId: null,
    };
  },
  mounted() {
    this.getData();
    this.refresh();
    // 轮询 this.getData(); 防止内存溢出
    // 每3秒执行一次
  },
  beforeDestroy() {
    // 清除 setInterval
    clearInterval(this.intervalId);
  },
  methods: {
    refresh() {
      // 集状态 0无数据 1处理中 2采集失败 3数据处理完成
      this.intervalId = setInterval(() => {
        try {
          if (this.collectCode !== '1' && this.collectCode !== '0') {
            clearInterval(this.intervalId);
          }
          this.getData();
        } catch (error) {
          console.error('getData failed:', error);
          // 可以在这里加入错误处理逻辑，比如重新尝试获取数据或通知用户
        }
      }, 3000);
    },
    async getData(val) {
      const { returnCode, returnMessage, data } = await this.$api.PublicPage.getCollectStatus({
        taxNo: this.$route.query.taxNo,
        orderId: this.$route.query.orderId,
      });
      if (returnCode === '200') {
        this.collectMessage = data.collectMessage;
        this.collectCode = data.collectCode;
        this.$emit('getCollectCode', {
          collectCode: data.collectCode,
          collectMessage: data.collectMessage,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
// .refresh {
//   height: 28px;
//   width: 64px;
//   border: 1px solid #ff6538;
//   border-radius: 4px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   font-family: PingFangSC-Regular;
//   font-size: 14px;
//   color: #ff6538;
//   text-align: center;
//   font-weight: 400;
//   .refreshIcon {
//     height: 12px;
//     width: 12px;
//     margin-right: 5px;
//   }
// }
.DataStatus {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 52px;
  font-family: "Microsoft YaHei";
  padding: 0 16px;
}
.text {
  margin-right: 10px;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #2f3133;
  font-weight: 600;
}
.textVal0 {
  background: #dadee4;
  border: 1px solid #46494d;
  border-radius: 4px;
  font-size: 10px;
  color: #46494d;
  padding: 0 4px;
}
.textVal1 {
  background: #f0f8ff;
  border: 1px solid #367ee8;
  border-radius: 4px;
  font-size: 10px;
  color: #367ee8;
  padding: 0 4px;
}
.textVal2 {
  background: #fff2f0;
  border: 1px solid #e83636;
  border-radius: 4px;
  font-size: 10px;
  color: #e83636;
  padding: 0 4px;
}
.textVal3 {
  background: #f0fffa;
  border: 1px solid #2fccb4;
  border-radius: 4px;
  font-size: 10px;
  color: #2fccb4;
  padding: 0 4px;
}
.status {
  display: flex;
  align-items: center;
}
.spinner {
  margin-right: 8px;
  font-size: 14px;
}
</style>
